import { render } from "./index.vue?vue&type=template&id=f32e4518"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/link-container/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f32e4518"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f32e4518', __exports__)) {
    api.reload('f32e4518', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f32e4518", () => {
    api.rerender('f32e4518', render)
  })

}


export default __exports__